export default __webpack_public_path__ + "fonts/titilliumweb-regular-webfont.eot";